import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from 'src/app/services/loading.service';
import { IntegrationsService } from '../../../services/integration/integrations.service';
import { TrainingLocationTypeModel } from '../../../models/training/training-location-type.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-gotowebinar',
    templateUrl: './gotowebinar.component.html',
    styleUrls: ['./gotowebinar.component.scss'],
    standalone: false
})
export class GotowebinarComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private integrationsService: IntegrationsService,
    private loadingService: LoadingService,
    private router: Router,
    private toastrService: ToastrService,
    private translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    const code = this.activatedRoute.snapshot.queryParams['code'] ?? null;

    if (code) {
      const obs = this.integrationsService.integrate(
        TrainingLocationTypeModel.GoToWebinar,
        code,
        IntegrationsService.goToWebinarRedirectUrl
      );
      this.loadingService.load(obs).subscribe(() => {
        this.toastrService.success(
          this.translateService.instant('INTEGRATIONS.GOTOWEBINAR-INTEGRATION-SUCCESSFUL')
        );
        this.router.navigate(['integrations']);
      });
    } else {
      this.router.navigate([IntegrationsService.integrationsUrl])
    }
  }
}
